import Section from './Section.vue'

export const linkModule = {
  type: 10000,
  component: Section,
  reset(localForm) {
    localForm.url_type = 'inner'
    localForm.jump_url = ''
  },
  fillFromActivity(localForm, raw) {
    const cfg = raw.config || {}
    localForm.url_type = cfg.url_type === 'outer' ? 'outer' : 'inner'
    localForm.jump_url = cfg.jump_url || ''
  },
  validate() {
    return true
  },
  buildPayload(localForm) {
    return {
      empty_config: {
        url_type: localForm.url_type,
        jump_url: localForm.jump_url,
      },
    }
  },
}

